export default "__VITE_ASSET__BxbAQREQ__"